import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import { useBrowsing } from 'hooks/use-browsing';

import { useUserStore } from 'stores/use-user-store';

import { PUBLIC_BASE_URL_ENV } from 'tools/environments';

import { Avatar } from 'core/generic/components/profile/avatar';

import { buildLoginUrl } from '../../utils/build-login-url';
import styles from './myaccount-button.module.scss';

export const MyAccountButton = () => {
	const { t } = useTranslation();
	const { isLoggedIn, profileData } = useUserStore((state) => ({
		isLoggedIn: state.user?.isLoggedIn,
		profileData: state.user,
	}));

	const router = useBrowsing();
	const currentPath = `${router.basePath}${router.asPath}`;
	const loginUrl = buildLoginUrl(currentPath);

	return (
		<Link
			href={isLoggedIn ? `${PUBLIC_BASE_URL_ENV}/account` : loginUrl}
			className={styles['my-account']}
			aria-label={
				isLoggedIn ? 'Go to My Account page' : 'Sign in to your account'
			}
			data-testid="my-account-link"
		>
			<Avatar
				image={{
					url: profileData?.avatar.url
						? `${PUBLIC_BASE_URL_ENV}/cdn-cgi/image/width=64,format=auto${profileData?.avatar.url}`
						: '',
				}}
				isWithBorder={profileData?.avatar.url ? false : true}
				dimension="xsmall"
			/>

			<span className={`${styles.text} body-small bold`}>
				{isLoggedIn
					? t('global.header:my_account', 'My Account')
					: t('global.header:sign_in', 'Sign in')}
			</span>
		</Link>
	);
};
